module.exports = __webpack_public_path__ + "static/media/email-footer.d8763b82.svg";